import React from "react";
const IconSecurePayment = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none" {...props}>
    <path
      d="M10.2267 13.6408C10.0238 24.0004 9.79416 35.7571 24.7704 41.1429C39.754 35.7571 39.519 23.9921 39.2528 13.6408V12.2047C33.9341 12.0747 28.8177 10.1894 24.7397 6.85718C20.6625 10.1894 15.546 12.0747 10.2267 12.2047V13.6408Z"
      stroke="currentColor"
      strokeWidth="currentStroke"
      strokeLinejoin="bevel"
    />
    <path
      d="M17.0356 24.066L22.646 29.1429L32.4642 19.7144"
      stroke="currentColor"
      strokeWidth="currentStroke"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconSecurePayment;
